module.exports = __webpack_public_path__ + "static/img/专利封面.a84e155.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/image/专利封面.jpg
// module id = PUNg
// module chunks = 1